import React, { useEffect, useState, useMemo, useRef } from "react";

import {
  Container,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Row,
  CardBody,
  Col,
  Card,
  CardHeader,
} from "reactstrap";

import { toast } from "react-toastify";

// RangeSlider
import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import DeleteModal from "../../Components/Common/DeleteModal";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "./TableContainer";
import { getSuppliers as getSuppliersApi } from "../../apiCalls/caller";
import { AgGridReact } from "ag-grid-react";
import { ModuleRegistry, CsvExportModule } from "ag-grid-community";
import {
  AllEnterpriseModule,
  LicenseManager,
  ExcelExportModule,
} from "ag-grid-enterprise";

//Import actions
import {
  getSuppliers as onGetSuppliers,
  updateSupplier as onUpdateSupplier,
  deleteSupplier as onDeleteSupplier,
} from "../../slices/thunks";

// import Select from "react-select";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import Loader from "../../Components/Common/Loader";
import AddSupplier from "./AddSupplier";
import EditSupplier from "./EditSupplier";
import { Box } from "@mui/material";
import DebouncedInput from "../../Components/Common/DebouncedInput";

ModuleRegistry.registerModules([CsvExportModule, ExcelExportModule, AllEnterpriseModule]);
LicenseManager.setLicenseKey(
  "Using_this_{AG_Grid}_Enterprise_key_{AG-076901}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Cartzy}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{BCAT}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{BCAT}_need_to_be_licensed___{BCAT}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{11_February_2026}____[v3]_[01]_MTc3MDc2ODAwMDAwMA==4a557ef1e71d7e706797c31212266eae"
);

const Suppliers = (props) => {
  const dispatch = useDispatch();
  const exportGridApiRef = useRef(null);
  const pendingExportRef = useRef(false);
  const [exportRowData, setExportRowData] = useState([]);
  const [isExporting, setIsExporting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isActiveSuppliers, setIsActiveSuppliers] = useState(false);
  const [showMovFilter, setShowMovFilter] = useState(false);
  const [movRange, setMovRange] = useState([0, 10000]);

  const [detailsModal, setDetailsModal] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [showAddSupplier, setShowAddSupplier] = useState(false);
  const [showEditSupplier, setShowEditSupplier] = useState(false);

  const selectSupplierData = createSelector(
    (state) => state.Suppliers,
    (products) => products.suppliers,
    (pagination) => pagination,
    (loading) => loading
  );
  // Inside your component
  const { suppliers, pagination, loading } = useSelector(selectSupplierData);

  const [suppliersList, setSuppliersList] = useState([]);
  const [selectedMulti, setselectedMulti] = useState(null);
  const [supplier, setSupplier] = useState(null);

  const [searchText, setSearchText] = useState(null);

  function handleMulti(selectedMulti) {
    setselectedMulti(selectedMulti);
  }

  useEffect(() => {
    if (suppliers) {
      setIsLoading(false);
      /*if (isActiveSuppliers) {
        const filteredSuppliers = suppliers.filter(
          (supplier) => supplier.sup_status === 0
        );
        setSuppliersList(filteredSuppliers);
      } else {
        setSuppliersList(suppliers);
      }*/
      setSuppliersList(suppliers);
      setFirstLoad(false);
    }
  }, [dispatch, suppliers]);
  /*
  useEffect(() => {
    setSuppliersList(suppliers);
  }, [suppliers]);

  useEffect(() => {
    if (!isEmpty(suppliers)) setSuppliersList(suppliers);
  }, [suppliers]);
*/

  useEffect(() => {
    !firstLoad && searchText && getSuppliers();
  }, [searchText]);

  const getSuppliers = (page, pageSize) => {
    setIsLoading(true);

    const data = {
      page: page ? page : 0,
      total_rows: pageSize ? pageSize : pagination ? pagination?.pageSize : 50,
      searchText: searchText,
      sort_by: "sup_name",
      asc: true,
      mov_from: parseInt(movRange[0]),
      mov_to: parseInt(movRange[1]),
      active: isActiveSuppliers,
    };
    dispatch(onGetSuppliers(data));
  };

  useEffect(() => {
    getSuppliers();
  }, [isActiveSuppliers, movRange]);

  //delete order
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const onClickDelete = (supplier) => {
    setSupplier(supplier);
    setDeleteModal(true);
  };

  const onClickView = (supplier) => {
    setSupplier(supplier);
    setDetailsModal(true);
  };

  const handleDeleteProduct = () => {
    if (supplier) {
      dispatch(onDeleteSupplier({ sup_id: supplier.sup_id }));
      setDeleteModal(false);
    }
  };

  // Displat Delete Button
  const [dele, setDele] = useState(0);
  const displayDelete = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element");
    setDele(ele.length);
    if (ele.length === 0) {
      del.style.display = "none";
    } else {
      del.style.display = "block";
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element");
    ele.forEach((element) => {
      dispatch(onDeleteSupplier(element.value));
      setTimeout(() => {
        toast.clearWaitingQueue();
      }, 3000);
      del.style.display = "none";
    });
  };

  const handleChangeMovRange = (event, newValue) => {
    setMovRange(newValue);
  };

  const exportColumnDefs = useMemo(
    () => [
      { headerName: "Name", field: "sup_name" },
      { headerName: "Company", field: "sup_company" },
      { headerName: "Status", field: "sup_status" },
      {
        headerName: "MOV",
        field: "sup_mov",
        valueFormatter: (params) =>
          params.value != null
            ? new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(params.value)
            : "",
      },
      { headerName: "Phone", field: "sup_phone" },
      { headerName: "Contact", field: "sup_contact" },
      { headerName: "Web Site", field: "sup_website" },
      { headerName: "Email", field: "sup_email" },
      { headerName: "Address", field: "sup_address" },
      { headerName: "City", field: "sup_city" },
      { headerName: "Country", field: "sup_country" },
      { headerName: "Notes", field: "sup_notes" },
    ],
    []
  );

  const handleExportXLSX = async () => {
    setIsExporting(true);
    try {
      const data = {
        page: 0,
        total_rows: 99999,
        searchText: searchText,
        sort_by: "sup_name",
        asc: true,
        mov_from: parseInt(movRange[0]),
        mov_to: parseInt(movRange[1]),
        active: isActiveSuppliers,
      };
      const response = await getSuppliersApi(data);
      if (response && response.data) {
        pendingExportRef.current = true;
        const mappedData = response.data.map((row) => ({
          ...row,
          sup_status: row.sup_status === 0 ? "Active" : "Inactive",
        }));
        setExportRowData(mappedData);
      } else {
        setIsExporting(false);
      }
    } catch (error) {
      toast.error("Error exporting suppliers");
      setIsExporting(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        header: "Name",
        accessorKey: "sup_name",
        enableColumnFilter: false,
      },
      {
        header: "MOV",
        accessorKey: "sup_mov",
        enableColumnFilter: false,
        cell: (cell) => {
          const value = cell.getValue();
          return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(value);
        },
      },
      {
        header: "Contact",
        accessorKey: "sup_contact",
        enableColumnFilter: false,
      },
      {
        header: "Phone",
        accessorKey: "sup_phone",
        enableColumnFilter: false,
      },
      {
        header: "Web Site",
        accessorKey: "sup_website",
        enableColumnFilter: false,
        cell: (cell) => {
          const value = cell.getValue();
          return (
            <a href={value} target="_blank" rel="noopener noreferrer">
              {value}
            </a>
          );
        },
      },
      {
        header: "Status",
        accessorKey: "sup_status",
        enableColumnFilter: false,
        cell: (cell) => {
          const value = cell.getValue();
          return (
            <span
              className={`badge text-dark ${
                value === 0 ? "bg-success" : "bg-danger"
              } text-uppercase`}
            >
              {value === 0 ? "Active" : "Inactive"}
            </span>
          );
        },
      },
      {
        header: "Action",
        cell: (cell) => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle
                href="#"
                className="btn btn-soft-secondary btn-sm"
                tag="button"
              >
                <i className="ri-more-fill" />
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                  onClick={() => {
                    const supplierData = cell.row.original;
                    setSupplier(supplierData);
                    setShowEditSupplier(true);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>{" "}
                  Edit
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    const supplierData = cell.row.original;

                    const updatedSupplierData = {
                      ...supplierData,
                      sup_status: cell.row.original.sup_status === 0 ? 1 : 0,
                    };
                    // Call the changeStatus function with the updated supplierData
                    dispatch(onUpdateSupplier(updatedSupplierData));
                  }}
                >
                  {cell.row.original.sup_status === 0 ? (
                    <i className="ri-close-circle-fill align-bottom me-2 text-muted"></i>
                  ) : (
                    <i className="ri-check-line align-bottom me-2 text-muted"></i>
                  )}{" "}
                  {cell.row.original.sup_status === 0
                    ? "Deactivate"
                    : "Activate"}
                </DropdownItem>

                <DropdownItem divider />
                <DropdownItem
                  href="#"
                  onClick={() => {
                    const supplierData = cell.row.original;
                    onClickDelete(supplierData);
                  }}
                >
                  <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>{" "}
                  Delete
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        },
      },
    ],
    []
  );

  document.title = "Suppliers | Buyers Club";

  return (
    <div className="page-content">
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteProduct}
        onCloseClick={() => setDeleteModal(false)}
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <AddSupplier
        open={showAddSupplier}
        onClose={() => setShowAddSupplier(false)}
      />
      <EditSupplier
        open={showEditSupplier}
        onClose={() => setShowEditSupplier(false)}
        supplier={supplier}
      />
      <Container fluid>
        <BreadCrumb title="Suppliers List" pageTitle="Suppliers" />
        <Row>
          <div className="col-xl-12">
            <Card id="orderList">
              <CardHeader className="border-0">
                <Row className="align-items-center gy-3">
                  <div className="col-sm">
                    <h5 className="card-title mb-0">Suppliers</h5>
                  </div>

                  <div className="col-sm-auto">
                    <div className="d-flex gap-3 flex-wrap">
                      <div className="d-flex gap-3  me-5">
                        <label htmlFor="movRange" className="mt-2">
                          Filter MOV:
                        </label>
                        <Box sx={{ width: 200 }} className="mt-3">
                          <Nouislider
                            start={movRange} //must be an array of two numbers
                            range={{ min: 0, max: 10000 }} //must be an object with min and max values
                            values={movRange} //must be an array of two numbers
                            connect
                            data-slider-color="primary"
                            id="product-price-range"
                            onEnd={(value) => setMovRange(value)}
                            step={1}
                            tooltips={true}
                          />
                        </Box>
                      </div>
                      <div className="form-check form-switch form-switch-md align-items-center">
                        <label className="form-check-label" htmlFor="bpaSwitch">
                          Show active suppliers Only
                        </label>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="bpaSwitch"
                          checked={isActiveSuppliers}
                          onChange={(e) =>
                            setIsActiveSuppliers(e.target.checked)
                          }
                        />
                      </div>
                      <div className="d-flex gap-3 mb-3">
                        <button
                          type="button"
                          className="btn btn-info"
                          onClick={handleExportXLSX}
                          disabled={isExporting}
                        >
                          <i className="ri-file-excel-2-line align-bottom me-1"></i>
                          {isExporting ? "Exporting..." : "Export XLSX"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-success add-btn"
                          id="create-btn"
                          onClick={() => {
                            setShowAddSupplier(true);
                          }}
                        >
                          <i className="ri-add-line align-bottom me-1"></i> Add
                          Supplier
                        </button>
                      </div>
                    </div>
                  </div>
                </Row>
              </CardHeader>

              <Row className="mb-3">
                <CardBody className="border border-dashed border-end-0 border-start-0">
                  <form>
                    <Row>
                      <Col sm={5}>
                        <div className="search-box me-2 mb-2 d-inline-block">
                          <DebouncedInput
                            value={searchText ?? ""}
                            onChange={(value) => setSearchText(value)}
                            placeholder="Search supplier"
                          />
                          <i className="bx bx-search-alt search-icon"></i>
                        </div>
                      </Col>
                    </Row>
                  </form>

                  <div>
                    {loading ? (
                      <Loader />
                    ) : suppliersList && suppliersList.length > 0 ? (
                      <TableContainer
                        columns={columns}
                        data={suppliersList || []}
                        isGlobalFilter={true}
                        isAddUserList={false}
                        customPageSize={10}
                        divClass="table-responsive mb-1"
                        tableClass="mb-0 align-middle table-borderless"
                        theadClass="table-light text-dark text-uppercase"
                        isProductsFilter={true}
                        SearchPlaceholder="Search Supplier..."
                        pagination={pagination}
                        manualPagination={true}
                        onPreviousPage={() => {
                          getSuppliers(pagination.currentPage - 1);
                        }}
                        onNextPage={() => {
                          getSuppliers(pagination.currentPage + 1);
                        }}
                        onGetPage={(page, pageSize) => {
                          getSuppliers(page, pageSize);
                        }}
                      />
                    ) : (
                      <div className="py-4 text-center">
                        <div>
                          <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="primary:#405189,secondary:#0ab39c"
                            style={{ width: "72px", height: "72px" }}
                          ></lord-icon>
                        </div>

                        <div className="mt-4">
                          <h5>Sorry! No Supliers Found</h5>
                        </div>
                      </div>
                    )}
                  </div>
                </CardBody>
              </Row>
            </Card>
          </div>
        </Row>
      </Container>
      <div
        style={{
          position: "absolute",
          left: "-99999px",
          top: "-99999px",
          width: "1200px",
          height: "400px",
        }}
      >
        <AgGridReact
          columnDefs={exportColumnDefs}
          rowData={exportRowData}
          onGridReady={(params) => {
            exportGridApiRef.current = params.api;
          }}
          onRowDataUpdated={(params) => {
            if (pendingExportRef.current) {
              pendingExportRef.current = false;
              params.api.exportDataAsExcel({
                fileName: "Suppliers_Export.xlsx",
              });
              setExportRowData([]);
              setIsExporting(false);
            }
          }}
        />
      </div>
    </div>
  );
};

export default Suppliers;
